import React from "react";
import { STAGES } from "../config/stages";

/*
Seven-node stage tracker plus the sub-status chips for the active stage.

Hand-rolled rather than reusing components/Stepper/StepperHorizontal.js, which
is MUI v5 with a hardcoded "show the last three + ellipsis" rule and a different
visual language.

Stage nodes are display-only: the stage comes from the ticket's `stage` field,
so it only changes through Advance/Revert in the header.
*/
const StageStepper = function (props) {
  const { stage, subStage, onSubStage, isComplete } = props;
  const active = STAGES[stage];

  return (
    <div className="tn-card tn-stepper-card">
      <ol className="tn-stepper">
        {STAGES.map(function (step, index) {
          const state = isComplete
            ? "done"
            : index < stage
            ? "done"
            : index === stage
            ? "current"
            : "todo";
          return (
            <li className="tn-step" key={step.key}>
              {index < STAGES.length - 1 ? (
                <span
                  className={
                    "tn-step-line" +
                    (isComplete || index < stage ? " tn-step-line-done" : "")
                  }
                />
              ) : null}
              <span
                className={"tn-step-node tn-step-" + state}
                title={step.label}
                aria-current={state === "current" ? "step" : undefined}
              >
                {state === "done" ? "✓" : index + 1}
              </span>
              <span className={"tn-step-label tn-step-label-" + state}>
                {step.label}
              </span>
            </li>
          );
        })}
      </ol>

      <div className="tn-substage">
        <div className="tn-substage-head">
          <span className="tn-eyebrow">Sub-status &mdash;</span>
          <span className="tn-substage-stage">{active.label}</span>
        </div>
        <div className="tn-substage-chips">
          {active.subStatuses.map(function (label, index) {
            const state = isComplete
              ? "done"
              : index < subStage
              ? "done"
              : index === subStage
              ? "current"
              : "todo";
            return (
              <button
                type="button"
                key={label}
                className={"tn-substage-chip tn-substage-" + state}
                onClick={function () {
                  onSubStage(index);
                }}
              >
                <span className="tn-substage-mark">
                  {state === "done" ? "✓" : index + 1}
                </span>
                {label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StageStepper;
